import { render, staticRenderFns } from "./Projectlist.vue?vue&type=template&id=8bc64580"
import script from "./Projectlist.vue?vue&type=script&lang=js"
export * from "./Projectlist.vue?vue&type=script&lang=js"
import style0 from "./Projectlist.vue?vue&type=style&index=0&id=8bc64580&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports